import Utils from '../../../utils';
import AuthApis from '../configs/auth.apis';

interface ILoginDto {
  emailOrNationalId: string;
  password: string;
  isPasswordVisible: boolean;
  isVerifyBySms: boolean;
}

class LoginDto implements ILoginDto {
  emailOrNationalId: string;
  password: string;
  isPasswordVisible: boolean;
  isVerifyBySms: boolean;

  constructor(data: Partial<ILoginDto>) {
    this.emailOrNationalId = data.emailOrNationalId || '';
    this.password = data.password || '';
    this.isPasswordVisible = data.isPasswordVisible || false;
    this.isVerifyBySms = data.isVerifyBySms ?? true;
  }

  /** Convert class to JSON object */
  toJson() {
    return {
      password: this.password,
      is_verify_by_sms: this.isVerifyBySms,
      // Case 1: If the input is a valid email address, send it as email
      ...(this.isEmail && { email: this.emailOrNationalId }),
      // Case 2: If the input is not a valid email address, send it as national_id
      ...(!this.isEmail && { national_id: this.emailOrNationalId }),
    };
  }

  toResetPasswordJson() {
    return {
      // Case 1: If the input is a valid email address, send it as email
      ...(this.isEmail && { email: this.emailOrNationalId }),
      // Case 2: If the input is not a valid email address, send it as national_id
      ...(!this.isEmail && { national_id: this.emailOrNationalId }),
    };
  }

  copyWith(data: Partial<ILoginDto>): LoginDto {
    return new LoginDto({ ...this, ...data });
  }

  /** Check if it is a valid email address */
  get isEmail(): boolean {
    return Utils.isEmailValid(this.emailOrNationalId);
  }

  /** Check if it is a valid password */
  get isPasswordValid(): boolean {
    return Utils.isValidPassword(this.password);
  }

  /** Check if it is a valid national id */
  get isValidNID(): boolean {
    return (
      (this.emailOrNationalId.startsWith('1') ||
        this.emailOrNationalId.startsWith('2')) &&
      this.emailOrNationalId.length === 10
    );
  }

  get isValidEmailNid(): boolean {
    return this.emailOrNationalId.trim() !== '' && (this.isEmail || this.isValidNID);
  }

  get isValid(): boolean {
    return this.isValidEmailNid && this.isPasswordValid;
  }

  get loginApi(): string {
    if (this.isEmail) {
      return AuthApis.loginByEmail;
    } else {
      return AuthApis.loginByNationalId;
    }
  }
}

export default LoginDto;
